import { fr, enUS, ptBR, es } from "date-fns/locale";
const localeMap = {
  fr,
  en: enUS,
  pt: ptBR,
  es,
};

export function getDateLocale(code) {
  const language = code?.slice(0, 2) || "en";
  const locale = localeMap[language];
  return locale;
}
